import React, { useState, FormEvent } from 'react';
import { updateCustomPublicId } from '../api';
import detailMessage from '../detailMessage';
import { useLang } from '../LangContext';

interface Props {
  token: string;
  initialSlug?: string | null;
  onChange?: (slug: string | null) => void;
}

const CustomSlugForm = ({ token, initialSlug, onChange }: Props) => {
  const { t } = useLang();
  const [slug, setSlug] = useState<string>(initialSlug || '');
  const [saved, setSaved] = useState<string>(initialSlug || '');
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [saving, setSaving] = useState<boolean>(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    const next = slug.trim().toLowerCase();
    setSaving(true);
    try {
      const res = await updateCustomPublicId(next === '' ? null as any : next, token);
      const nextSaved = res.custom_public_id || '';
      setSlug(nextSaved);
      setSaved(nextSaved);
      onChange?.(nextSaved || null);
      setSuccess(nextSaved ? t.customSlugUpdated : t.customSlugCleared);
      setTimeout(() => setSuccess(''), 6000);
    } catch (err) {
      setError(detailMessage(err, t.customSlugFailed));
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="custom-slug-section">
      <h4>{t.customSlugHeading}</h4>
      <p className="duration-options-hint">
        {t.customSlugHint}
      </p>

      {error && <div className="error-message"><strong>{t.errorLabel2}</strong> {error}</div>}
      {success && <div className="success-message"><strong>✓</strong> {success}</div>}

      <form className="custom-slug-form" onSubmit={handleSubmit}>
        <input
          type="text"
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
          placeholder={t.customSlugPlaceholder}
          disabled={saving}
          maxLength={32}
          spellCheck={false}
          autoCapitalize="none"
        />
        <button
          type="submit"
          className="submit-button"
          disabled={saving || slug.trim().toLowerCase() === saved}
        >
          {saving ? t.customSlugSaving : slug.trim() === '' ? t.customSlugClear : t.customSlugSave}
        </button>
      </form>
    </section>
  );
};

export default CustomSlugForm;
